import { segmentAnalytics as analytics } from '@hungryroot/segment';
interface Params {
  pairingId: number;
  pairingName: string;
  category: 'pairings' | 'products';
  location: 'card' | 'RDP' | 'PDP';
  path: string;
  state: boolean;
}

export function trackSaveRecipe(params: Params) {
  const { pairingId, pairingName, category, location, path, state } = params;
  analytics.track('Product Saved', {
    product_id: pairingId,
    pairing_name: pairingName,
    category,
    location,
    path,
    state: state === true ? 1 : 0,
    source: 'web',
  });
}
